/**
 * A tag's Tag Type — mirrors the shared `GatewayInputDataTypeEnum`'s values,
 * kept local so `TagRow` and the modal's form don't depend on the app-wide
 * gateways types module for what business logic here treats as its own
 * value set: row visibility, Category options, and Relevant Mode gating all
 * branch on specific members of it.
 */
export const TAG_TYPE = {
  ALARM: 'alarm',
  MODE: 'mode',
  STATE: 'state',
  SENSOR_DATA: 'sensor_data',
  OUTPUT: 'output',
  SETPOINT: 'setpoint',
  CALCULATED: 'calculated',
} as const;

export type TagTypeValue = (typeof TAG_TYPE)[keyof typeof TAG_TYPE];
